// Esc は実行中でも入口に戻すだけにし、中断は停止ボタンで行う。
// シートの編集や ⌘K の操作を奪わないよう、ウィジェット内で受けた Esc だけを扱う。

import { isComposingKey } from './imeComposition'

// Esc を自分で扱う antd のポップアップ（メニュー、確認のダイアログなど）。中の Esc はそれを閉じるだけにする
export const POPUP_SELECTOR = '.ant-popover, .ant-dropdown, .ant-modal'

/**
 * ウィジェットとして扱う Esc かを返す。日本語の変換中の Esc（変換の取り消し。isComposingKey）と、ポップアップの中の Esc は扱わない。
 */
export const isWidgetEscape = ({
  key,
  isComposing,
  keyCode,
  insidePopup,
}: {
  key: string
  isComposing: boolean
  keyCode: number
  insidePopup: boolean
}): boolean => key === 'Escape' && !isComposingKey({ isComposing, keyCode }) && !insidePopup

/**
 * フォーカスはないが、マウスのポインターがウィジェットの上にあるときに扱う Esc かを返す。
 * 入口を押して開くと押したボタンが消えてフォーカスが外れるので、フォーカスでは受けられないためである。
 * ほかの場所（シートのセルの編集など）にフォーカスがあるときは、そちらの Esc を優先して扱わない。
 */
export const isHoverEscape = ({
  key,
  isComposing,
  keyCode,
  nothingFocused,
}: {
  key: string
  isComposing: boolean
  keyCode: number
  nothingFocused: boolean
}): boolean => key === 'Escape' && !isComposingKey({ isComposing, keyCode }) && nothingFocused
